/*
  This file lists the font families and fallbacks used in email templates.

  "value" should be a simple identifier for the font (usually its name). It is
  referenced inside template settings, stored on the server, and used as the
  label for a font (unless "label" is defined).

  "stack" is a string that includes the original font and its fallbacks. This
  is beneficial for clients that don't have the original font installed.

  "label" is an optional string that will be shown in the font select dropdown.
  If it isn't defined, the "value" will be used instead.
*/

const SYSTEM_FONTS =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif"

export default [
  {
    label: "System Font",
    value: SYSTEM_FONTS,
    stack: SYSTEM_FONTS
  },
  {
    value: "Arial",
    stack: `Arial, ${SYSTEM_FONTS}`
  },
  {
    value: "Arial Black",
    stack: `"Arial Black", "Arial Bold", ${SYSTEM_FONTS}`
  },
  {
    value: "Century Gothic",
    stack: `'Century Gothic', Avenir, 'Trebuchet MS', ${SYSTEM_FONTS}`
  },
  {
    value: "Courier New",
    stack: `'Courier New', Courier, monospace`
  },
  {
    value: "Geneva",
    stack: `Geneva, Calibri, ${SYSTEM_FONTS}`
  },
  {
    value: "Georgia",
    stack: `Georgia, Times, 'Times New Roman', serif`
  },
  {
    value: "Lucida Grande",
    stack: `'Lucida Grande', Verdana`
  },
  {
    value: "New York",
    stack: `'New York', Charter, Georgia, serif`
  },
  {
    value: "Charter",
    stack: `Charter, Georgia, Times, 'Times New Roman', serif`
  },
  {
    value: "Tahoma",
    stack: `Tahoma, 'PT Sans', Ubuntu, ${SYSTEM_FONTS}`
  },
  {
    value: "Times New Roman",
    stack: `'Times New Roman', Times, Georgia, serif`
  },
  {
    value: "Verdana",
    stack: `Verdana, ${SYSTEM_FONTS}`
  }
]
